import { gql, useQuery } from "@apollo/client";

const GET_MEMBER_CLIENTS = gql`
  query getMemberClients($memberId: ID!) {
    account {
      id
      member(id: $memberId) {
        clients {
          id
          accountName
        }
      }
    }
  }
`;

export const useMemberClients = memberId => {
  const { data, loading, error } = useQuery(GET_MEMBER_CLIENTS, {
    variables: {
      memberId
    },
    fetchPolicy: "network-only"
  });

  const clientAccounts =
    data?.account?.member?.clients?.reduce((acc, client) => {
      return [
        ...acc,
        {
          id: client.id,
          name: client.accountName
        }
      ];
    }, []) || [];

  return {
    clientAccounts,
    loading,
    error
  };
};
